import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'We had a CRM, but it was not satisfactory. Evaluations were impossible, a lot of manual work. Now we have clean KPIs, a smooth workflow, and the automations are simple, clear, and they work - that is what counts in the end.',
  author: 'Thorsten Wittmann',
  role: 'Managing Director',
  company: 'TWI International',
  rating: 5
}, {
  quote: 'The simplicity for our sales team is perfect. The workflow is completely streamlined and optimized. The call volume has doubled to tripled - resulting in a 30 to 50 percent increase in revenue through the collaboration.',
  author: 'Samin Quraischi',
  role: 'Co-Founder',
  company: 'Hiit The Beat',
  rating: 5
}, {
  quote: 'I just scheduled the first setting and it is simply insane how it switches over automatically. The automation works perfectly and saves us an extreme amount of time in sales.',
  author: 'Ray Dettmann',
  role: 'Head of Sales',
  company: 'Dreamlife.now',
  rating: 5
}, {
  quote: 'Increased revenue from 30k to 80k. Turned up the ad budget to 15,000€. My team only focuses on calls - everything else runs automatically. We easily have 200 dial attempts per employee. 10 out of 10 satisfaction.',
  author: 'Thomas Bux',
  role: 'Managing Director',
  company: 'Bux Consulting',
  rating: 5
}, {
  quote: 'From Excel lists to complete order. The call volume has doubled. I was able to listen to all recordings and see who is really good. Constant growth without 14-hour days. Everything implemented very quickly.',
  author: 'Viktor Bajtinger',
  role: 'Managing Director',
  company: 'Self-Employment Coaching',
  rating: 5
}, {
  quote: 'From 28k to 92k net order volume with 2 people. 300-450 dial attempts per day instead of 100. One employee now manages what I used to need 2-3 people for. Productivity has doubled, tripled, quadrupled. Absolute game changer.',
  author: 'Mario Amadori',
  role: 'Managing Director',
  company: 'E-Commerce Coaching',
  rating: 5
}];
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-24 lg:py-32 bg-[#0a0a0a]" ref={ref} data-id="element-311">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-312">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-313">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#0ea5e9]/10 text-[#0ea5e9] text-sm font-medium mb-6" data-id="element-314">
            Client Testimonials
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-315">
            What our clients say
          </h2>
          <p className="mt-6 text-lg text-gray-400" data-id="element-316">
            Over 110 companies trust our Close CRM expertise. Here are some of
            their experiences.
          </p>
          <p className="text-center text-sm text-gray-600 mb-8" data-id="element-317">
            TRUSTED BY 110+ ENTREPRENEURS
          </p>
        </motion.div>

        {/* Rating summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex flex-wrap justify-center items-center gap-8 mb-12" data-id="element-318">
          <div className="flex items-center gap-2" data-id="element-319">
            <div className="flex" data-id="element-320">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-321" />)}
            </div>
            <span className="text-white font-bold text-xl" data-id="element-322">5.0</span>
          </div>
          <span className="text-gray-500" data-id="element-323">|</span>
          <span className="text-gray-400" data-id="element-324">Based on 110+ reviews</span>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-325">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 + index * 0.1
        }} className="p-6 rounded-2xl bg-[#1a1a1a] border border-white/5" data-id="element-326">
              <div className="flex gap-1 mb-4" data-id="element-327">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-328" />)}
              </div>
              <p className="text-gray-300 leading-relaxed mb-6" data-id="element-329">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/5" data-id="element-330">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#0ea5e9] to-[#06b6d4] flex items-center justify-center text-white font-semibold text-sm" data-id="element-331">
                  {testimonial.author.split(' ').map(n => n[0]).join('')}
                </div>
                <div data-id="element-332">
                  <p className="text-white font-medium text-sm" data-id="element-333">
                    {testimonial.author}
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-334">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}